import RefreshTokenService from "../services/RefreshTokenService";
import { authCookieExists, refreshCookieExists } from "../utilities/cookies";

export async function checkAuthentication(): Promise<boolean> {
  if (authCookieExists()) {
    return true;
  }

  if (refreshCookieExists()) {
    return await RefreshTokenService.do();
  }

  return false;
}
